export default __webpack_public_path__ + "static/prosper-mobile-b934940868394964c7b065d71d7d349e.svg";